import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    padding: `${theme.spacing(4)}px 0px`,
    width: '80%',
    maxWidth: 600,
    margin: '0 auto',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: 'inherit',
      margin: 0,
    },
  },
  tagButton: {
    color: theme.colors.blue,
    borderColor: theme.colors.blue,
  },
  tagRemove: {
    color: theme.colors.danger,
    borderColor: theme.colors.danger,
  },
  doubleIcon: {
    position: 'relative',
    height: 24,
  },
  plusIcon: {
    position: 'absolute',
    top: 12,
    right: -2,
    fontSize: 14,
  },
  formContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
  },
}));

export default useStyles;
